import { render } from "./SuggestBox.vue?vue&type=template&id=e99750b4&scoped=true&ts=true"
import script from "./SuggestBox.vue?vue&type=script&lang=ts"
export * from "./SuggestBox.vue?vue&type=script&lang=ts"

import "./SuggestBox.vue?vue&type=style&index=0&id=e99750b4&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99750b4"]])

export default __exports__